import {
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Char__compareTo_impl_ypi4mb252jweqlvw9s as Char__compareTo_impl_ypi4mb,
  Unit_instanceat14thlj150z as Unit_instance,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  get_indices38nlqzzvtaclf as get_indices,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  getOrNull1cdnsfrisdp41 as getOrNull,
  isLowSurrogateujxcv7hjn4ma as isLowSurrogate,
  Char19o2r8palgjof as Char,
  isHighSurrogate11jfjw70ar0zf as isHighSurrogate,
  toCharArray32huqyw9tt7kx as toCharArray,
  booleanArray2jdug9b51huk7 as booleanArray,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  StringBuildermazzzhj6kkai as StringBuilder,
  decodeToString1dbzcjd620q25 as decodeToString,
  toString14fd7g605f91p as toString,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString_0,
  toInt5qdj874w69jh as toInt,
  toByte4i43936u611k as toByte,
  NumberFormatException3bgsm2s9o4t55 as NumberFormatException,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  concatToString2syawgu50khxi as concatToString,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  contains2el4s70rdq4ld as contains,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Character {
  constructor() {
    Character_instance = this;
    this.mdf_1 = 1114111;
    this.ndf_1 = 65536;
    this.odf_1 = -56613888;
    this.pdf_1 = _Char___init__impl__6a9atx(55232);
  }
  qdf(codePoint) {
    return 65536 <= codePoint ? codePoint <= 1114111 : false;
  }
  rdf(highSurrogate, lowSurrogate) {
    // Inline function 'kotlin.code' call
    var tmp = Char__toInt_impl_vasixd(highSurrogate) << 10;
    // Inline function 'kotlin.code' call
    return (tmp + Char__toInt_impl_vasixd(lowSurrogate) | 0) + -56613888 | 0;
  }
  sdf(codePoint) {
    return (codePoint >>> 16 | 0) === 0;
  }
  tdf(codePoint) {
    var tmp = codePoint >>> 10 | 0;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(55232);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    return numberToChar(tmp + tmp$ret$0 | 0);
  }
  udf(codePoint) {
    var tmp = codePoint & 1023;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(56320);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    return numberToChar(tmp + tmp$ret$0 | 0);
  }
}
class UrlEncoderUtil {
  constructor() {
    UrlEncoderUtil_instance = this;
    this.vdf_1 = toCharArray('0123456789ABCDEF');
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = booleanArray(123);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.thauvin.erik.urlencoder.UrlEncoderUtil.unreservedChars.<anonymous>' call
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(45);
    this_0[Char__toInt_impl_vasixd(this_1)] = true;
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(46);
    this_0[Char__toInt_impl_vasixd(this_2)] = true;
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(95);
    this_0[Char__toInt_impl_vasixd(this_3)] = true;
    var inductionVariable = _Char___init__impl__6a9atx(48);
    if (inductionVariable <= _Char___init__impl__6a9atx(57))
      do {
        var c = inductionVariable;
        inductionVariable = Char__plus_impl_qi7pgj(inductionVariable, 1);
        // Inline function 'kotlin.code' call
        this_0[Char__toInt_impl_vasixd(c)] = true;
      }
       while (inductionVariable <= _Char___init__impl__6a9atx(57));
    var inductionVariable_0 = _Char___init__impl__6a9atx(65);
    if (inductionVariable_0 <= _Char___init__impl__6a9atx(90))
      do {
        var c_0 = inductionVariable_0;
        inductionVariable_0 = Char__plus_impl_qi7pgj(inductionVariable_0, 1);
        // Inline function 'kotlin.code' call
        this_0[Char__toInt_impl_vasixd(c_0)] = true;
      }
       while (inductionVariable_0 <= _Char___init__impl__6a9atx(90));
    var inductionVariable_1 = _Char___init__impl__6a9atx(97);
    if (inductionVariable_1 <= _Char___init__impl__6a9atx(122))
      do {
        var c_1 = inductionVariable_1;
        inductionVariable_1 = Char__plus_impl_qi7pgj(inductionVariable_1, 1);
        // Inline function 'kotlin.code' call
        this_0[Char__toInt_impl_vasixd(c_1)] = true;
      }
       while (inductionVariable_1 <= _Char___init__impl__6a9atx(122));
    tmp.wdf_1 = this_0;
  }
  y49(source, plusToSpace) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(source) === 0) {
      return source;
    }
    var length = source.length;
    var out = StringBuilder.mc(length);
    var bytesBuffer = null;
    var bytesPos = 0;
    var i = 0;
    var started = false;
    while (i < length) {
      var ch = charSequenceGet(source, i);
      if (ch === _Char___init__impl__6a9atx(37)) {
        if (!started) {
          out.oh(source, 0, i);
          started = true;
        }
        if (bytesBuffer == null) {
          bytesBuffer = new Int8Array((length - i | 0) / 3 | 0);
        }
        i = i + 1 | 0;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length >= (i + 2 | 0))) {
          // Inline function 'net.thauvin.erik.urlencoder.UrlEncoderUtil.decode.<anonymous>' call
          var message = 'Incomplete trailing escape (' + toString(ch) + ') pattern';
          throw IllegalArgumentException.l(toString_0(message));
        }
        try {
          // Inline function 'kotlin.text.substring' call
          var startIndex = i;
          var endIndex = i + 2 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$3 = source.substring(startIndex, endIndex);
          var v = toInt(tmp$ret$3, 16);
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.contracts.contract' call
          if (!(0 <= v ? v <= 255 : false)) {
            // Inline function 'net.thauvin.erik.urlencoder.UrlEncoderUtil.decode.<anonymous>' call
            var message_0 = 'Illegal escape value';
            throw IllegalArgumentException.l(toString_0(message_0));
          }
          var tmp = bytesBuffer;
          var tmp1 = bytesPos;
          bytesPos = tmp1 + 1 | 0;
          tmp[tmp1] = toByte(v);
          i = i + 2 | 0;
        } catch ($p) {
          if ($p instanceof NumberFormatException) {
            var e = $p;
            throw IllegalArgumentException.te('Illegal characters in escape sequence: ' + e.toString() + '.message', e);
          } else {
            throw $p;
          }
        }
      } else {
        if (!(bytesBuffer == null)) {
          out.gc(decodeToString(bytesBuffer, 0, bytesPos));
          started = true;
          bytesBuffer = null;
          bytesPos = 0;
        }
        if (plusToSpace && ch === _Char___init__impl__6a9atx(43)) {
          if (!started) {
            out.oh(source, 0, i);
            started = true;
          }
          out.gc(' ');
        } else if (started) {
          out.hc(ch);
        }
        i = i + 1 | 0;
      }
    }
    if (!(bytesBuffer == null)) {
      out.gc(decodeToString(bytesBuffer, 0, bytesPos));
    }
    return !started ? source : out.toString();
  }
  xdf(source, allow, spaceToPlus) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(source) === 0) {
      return source;
    }
    var out = null;
    var i = 0;
    while (i < source.length) {
      var ch = charSequenceGet(source, i);
      if (isUnreserved(ch, this) || contains(allow, ch)) {
        var tmp0_safe_receiver = out;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver.hc(ch);
        i = i + 1 | 0;
      } else {
        if (out == null) {
          out = StringBuilder.mc(source.length);
          out.oh(source, 0, i);
        }
        var cp = codePointAt(source, this, i);
        if (cp < 128) {
          if (spaceToPlus && ch === _Char___init__impl__6a9atx(32)) {
            out.hc(_Char___init__impl__6a9atx(43));
          } else {
            appendEncodedByte(out, this, cp);
          }
          i = i + 1 | 0;
        } else if (Character_getInstance().sdf(cp)) {
          var indexedObject = encodeToByteArray(toString(ch));
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var b = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            appendEncodedByte(out, this, b);
          }
          i = i + 1 | 0;
        } else if (Character_getInstance().qdf(cp)) {
          var high = Character_getInstance().tdf(cp);
          var low = Character_getInstance().udf(cp);
          // Inline function 'kotlin.charArrayOf' call
          var tmp$ret$1 = charArrayOf([high, low]);
          var indexedObject_0 = encodeToByteArray(concatToString(tmp$ret$1));
          var inductionVariable_0 = 0;
          var last_0 = indexedObject_0.length;
          while (inductionVariable_0 < last_0) {
            var b_0 = indexedObject_0[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            appendEncodedByte(out, this, b_0);
          }
          i = i + 2 | 0;
        }
      }
    }
    var tmp6_safe_receiver = out;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.toString();
    return tmp7_elvis_lhs == null ? source : tmp7_elvis_lhs;
  }
}
//endregion
var Character_instance;
function Character_getInstance() {
  if (Character_instance === VOID)
    new Character();
  return Character_instance;
}
function isUnreserved(_this__u8e3s4, $this) {
  var tmp;
  if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(122)) <= 0) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(_this__u8e3s4);
    tmp = $this.wdf_1[tmp$ret$0];
  } else {
    tmp = false;
  }
  return tmp;
}
function appendEncodedDigit(_this__u8e3s4, $this, digit) {
  _this__u8e3s4.hc($this.vdf_1[digit & 15]);
}
function appendEncodedByte(_this__u8e3s4, $this, ch) {
  _this__u8e3s4.gc('%');
  appendEncodedDigit(_this__u8e3s4, $this, ch >> 4);
  appendEncodedDigit(_this__u8e3s4, $this, ch);
}
function codePointAt(_this__u8e3s4, $this, index) {
  if (!(0 <= index ? index <= (charSequenceLength(_this__u8e3s4) - 1 | 0) : false))
    throw IndexOutOfBoundsException.ze('index ' + index + ' was not in range ' + get_indices(_this__u8e3s4).toString());
  var firstChar = charSequenceGet(_this__u8e3s4, index);
  if (isHighSurrogate(firstChar)) {
    var nextChar = getOrNull(_this__u8e3s4, index + 1 | 0);
    var tmp;
    var tmp_0 = nextChar;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = isLowSurrogate(nextChar);
    }
    if (tmp === true) {
      return Character_getInstance().rdf(firstChar, nextChar);
    }
  }
  // Inline function 'kotlin.code' call
  return Char__toInt_impl_vasixd(firstChar);
}
var UrlEncoderUtil_instance;
function UrlEncoderUtil_getInstance() {
  if (UrlEncoderUtil_instance === VOID)
    new UrlEncoderUtil();
  return UrlEncoderUtil_instance;
}
//region block: post-declaration
initMetadataForObject(Character, 'Character');
initMetadataForObject(UrlEncoderUtil, 'UrlEncoderUtil');
//endregion
//region block: exports
export {
  UrlEncoderUtil_getInstance as UrlEncoderUtil_getInstance1qxz1r0ptmfgt,
};
//endregion
